import { useRouter } from 'next/router';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import Login from '../../components/Auth/Login';
import Seo from '../../components/Seo';
import { Button, H1, Spacing } from '../../components/ui';
import Container, { FlexContainer } from '../../components/ui/Container';
import { LineRoundedChevron } from '../../components/ui/icons/exported/lineRoundedChevron';
import LineRoundedWrapper from '../../components/ui/icons/exported/lineRoundedWrapper';
import { Logo } from '../../components/ui/Logo';
import { RootState } from '../../store';
import { useBreakpoints } from '../../utils';

const LogInPage: FC = () => {
  const { isSmallScreen } = useBreakpoints();
  const router = useRouter();
  const padding = isSmallScreen ? 'sm' : 'lg';
  const authUser = useSelector((state: RootState) => state.auth.user);

  if (authUser && authUser._id) {
    router.push('/');
    return <></>;
  }

  return (
    <FlexContainer
      padding={padding}
      align="center"
      flexDirection="column"
      justify="center"
      style={{ height: '100vh', position: 'relative' }}
    >
      <Seo title="Log In" />
      <Container shadow="pya" bgColor="white" radius="lg" maxWidth="xs">
        <FlexContainer justify="center">
          <Spacing bottom="none">
            <Logo width={125} height={50} />
          </Spacing>
        </FlexContainer>
        <FlexContainer style={{ position: 'relative' }}>
          {isSmallScreen && (
            <Button ghost onClick={() => router.back()} shadow={false}>
              <LineRoundedWrapper
                style={{ rotate: '90deg', position: 'absolute', left: 0, top: 0 }}
                width="24px"
                height="24px"
              >
                <LineRoundedChevron stroke="black" />
              </LineRoundedWrapper>
            </Button>
          )}
        </FlexContainer>
        <FlexContainer
          flexDirection="column"
          justify="center"
          align="center"
          style={{ maxWidth: '600px', flexGrow: 1 }}
        >
          <H1>Log In</H1>
          <Login />
        </FlexContainer>
      </Container>
    </FlexContainer>
  );
};

export default LogInPage;
